
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree935"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree935"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7ebdb0cede39ab85$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["fKUle","pong.9b4d9343.js","gluHx","ping.84740ffe.wav"]'));

var $d1296e6d8662977b$exports = {};
var $0dd05d01d611bc80$var$getRandomDirection = function() {
    return Math.random() > 0.5 ? 1 : -1;
};
var $0dd05d01d611bc80$export$a83d7c3fa53790c9 = /** @class */ function() {
    function Ball(canvas, pad, player2, sound, orquestrer) {
        this.canvas = canvas;
        this.sound = sound;
        this.pad = pad;
        this.player2 = player2;
        this.positionX = 450;
        this.positionY = 300;
        this.speed = 9;
        this.directionX = $0dd05d01d611bc80$var$getRandomDirection();
        this.directionY = $0dd05d01d611bc80$var$getRandomDirection();
        this.width = 10;
        this.height = 10;
        this.colorBall = "#FAFAFA";
        this.orquestrer = orquestrer;
    }
    Ball.prototype.updateColorBall = function(newHexValue) {
        this.colorBall = newHexValue;
    };
    Ball.prototype.handleMovement = function() {
        var playerPassRightBall = this.pad.drawPosX + this.pad.drawWidth >= this.positionX && this.positionX <= this.pad.drawPosX;
        var playerInsideTopBoundaryBall = this.positionY >= this.pad.drawPosY;
        var playerInsideBottomBoundaryBall = this.positionY <= this.pad.drawPosY + this.pad.drawHeight;
        var playerCollision = playerPassRightBall && playerInsideTopBoundaryBall && playerInsideBottomBoundaryBall;
        if (this.positionX <= 0 || playerCollision) {
            this.sound.play();
            this.directionX = 1;
        }
        if (this.positionX <= 0) {
            this.orquestrer.player2Points += 1;
            this.orquestrer.stop();
        }
        var aiPassRightBall = this.positionX + this.width >= this.player2.drawPosX && this.positionX + this.width <= this.player2.drawPosX + this.player2.drawWidth;
        var aiInsideTopBoundaryBall = this.positionY >= this.player2.drawPosY;
        var aiInsideBottomBoundaryBall = this.positionY <= this.player2.drawPosY + this.player2.drawHeight;
        if (this.positionX + this.width >= this.canvas.width) {
            this.orquestrer.player1Points += 1;
            this.orquestrer.stop();
        }
        var aiCollision = aiPassRightBall && aiInsideTopBoundaryBall && aiInsideBottomBoundaryBall;
        if (this.positionX + this.width >= this.canvas.width || aiCollision) {
            this.sound.play();
            this.directionX = -1;
        }
        if (this.positionY <= 0) {
            this.sound.play();
            this.directionY = 1;
        }
        if (this.positionY + this.height >= this.canvas.height) {
            this.sound.play();
            this.directionY = -1;
        }
    };
    Ball.prototype.render = function() {
        if (this.orquestrer.isPlaying) {
            this.positionX += this.speed * this.directionX;
            this.positionY += this.speed * this.directionY;
            this.handleMovement();
        }
        this.canvas.canvasContext.beginPath();
        this.canvas.canvasContext.fillStyle = this.colorBall;
        this.canvas.canvasContext.fillRect(this.positionX, this.positionY, this.width, this.height);
        this.canvas.canvasContext.closePath();
    };
    return Ball;
}();


var $e5f72513d35cfb6f$export$8d01c972ee8b14a9 = /** @class */ function() {
    function Canvas(orquestrer) {
        this.orquestrer = orquestrer;
        this.canvasElement = document.getElementById("canvas");
        this.canvasContext = this.canvasElement.getContext("2d");
        this.x = 0;
        this.y = 0;
        this.width = 900;
        this.height = 600;
    }
    Canvas.prototype.render = function() {
        this.canvasContext.beginPath();
        this.canvasContext.fillStyle = "#ffd4e3";
        this.canvasContext.fillRect(this.width / 2 - 1, 0, 2, this.height);
        this.canvasContext.closePath();
        if (!this.orquestrer.isPlaying) {
            this.canvasContext.beginPath();
            this.canvasContext.font = "30px Arial";
            this.canvasContext.fillStyle = "#ffd4e3";
            this.canvasContext.textAlign = "center";
            this.canvasContext.fillText("Pressione Espa\xe7o para continuar", this.width / 2, this.height / 2);
            this.canvasContext.fillText("shift para ganhar velocidade", this.width / 2, this.height / 2 + 40);
            this.canvasContext.closePath();
        }
        this.canvasContext.beginPath();
        this.canvasContext.font = "40px Arial";
        this.canvasContext.textAlign = "center";
        this.canvasContext.fillStyle = "#ffd4e3";
        this.canvasContext.fillText("".concat(this.orquestrer.player1Points, "   ").concat(this.orquestrer.player2Points), this.width / 2, 50);
        this.canvasContext.closePath();
    };
    return Canvas;
}();


var $e622a235c1574eb5$export$6a77e7ef76b918fb = /** @class */ function() {
    function KeyBoardHandler() {
        var _this = this;
        this.keyboardState = {
            KeyW: false,
            KeyA: false,
            KeyS: false,
            KeyD: false,
            Space: false,
            ShiftLeft: false,
            Numpad0: false,
            ArrowUp: false,
            ArrowLeft: false,
            ArrowRight: false,
            ArrowDown: false
        };
        var moves = {
            KeyW: function(newValue) {
                _this.keyboardState.KeyW = newValue;
            },
            KeyS: function(newValue) {
                _this.keyboardState.KeyS = newValue;
            },
            KeyA: function(newValue) {
                _this.keyboardState.KeyA = newValue;
            },
            KeyD: function(newValue) {
                _this.keyboardState.KeyD = newValue;
            },
            ShiftLeft: function(newValue) {
                _this.keyboardState.ShiftLeft = newValue;
            },
            Space: function(newValue) {
                _this.keyboardState.Space = newValue;
            },
            Numpad0: function(newValue) {
                _this.keyboardState.Numpad0 = newValue;
            },
            ArrowUp: function(newValue) {
                _this.keyboardState.ArrowUp = newValue;
            },
            ArrowLeft: function(newValue) {
                _this.keyboardState.ArrowLeft = newValue;
            },
            ArrowRight: function(newValue) {
                _this.keyboardState.ArrowRight = newValue;
            },
            ArrowDown: function(newValue) {
                _this.keyboardState.ArrowDown = newValue;
            }
        };
        window.addEventListener("keydown", function(event) {
            var _a;
            console.log(event.code);
            (_a = moves[event.code]) === null || _a === void 0 || _a.call(moves, true);
        });
        window.addEventListener("keyup", function(event) {
            var _a;
            (_a = moves[event.code]) === null || _a === void 0 || _a.call(moves, false);
        });
    }
    return KeyBoardHandler;
}();


var $b724957aa8e823eb$export$cc1d9215c4c9725c = /** @class */ function() {
    function Orquestrer() {
        this.isPlaying = false;
        this.player1Points = 0;
        this.player2Points = 0;
    }
    Orquestrer.prototype.reset = function() {
        this.isPlaying = false;
        this.player1Points = 0;
        this.player2Points = 0;
    };
    Orquestrer.prototype.start = function() {
        this.isPlaying = true; //true;
    };
    Orquestrer.prototype.stop = function() {
    // this.isPlaying = false;
    };
    Orquestrer.prototype.getPlacar = function() {
        return {
            player1Points: this.player1Points,
            player2Points: this.player2Points
        };
    };
    return Orquestrer;
}();


var $7c6ee2a7bfeaced6$var$timeInMsToUpdateSprite = 150;
var $7c6ee2a7bfeaced6$var$spriteActive = 0;
setInterval(function() {
    $7c6ee2a7bfeaced6$var$spriteActive += 1;
    if ($7c6ee2a7bfeaced6$var$spriteActive >= 4) $7c6ee2a7bfeaced6$var$spriteActive = 0;
}, $7c6ee2a7bfeaced6$var$timeInMsToUpdateSprite);
var $7c6ee2a7bfeaced6$var$directionColWalkSprite = {
    Bottom: 0,
    Left: 1,
    Right: 2,
    Top: 3
};
var $7c6ee2a7bfeaced6$export$4b43d51f29457384 = /** @class */ function() {
    function Pad(canvas, orquestrer, side) {
        this.orquestrer = orquestrer;
        this.canvas = canvas;
        this.speed = 8;
        this.side = side;
        this.finalSpeed = this.speed;
        this.drawWidth = 10;
        this.drawHeight = 70;
        var centralPosition = this.canvas.height / 2 - this.drawHeight / 2;
        if (side === "Left") {
            this.drawPosX = this.canvas.width / 10;
            this.drawPosY = centralPosition;
        } else {
            this.drawPosX = this.canvas.width - this.canvas.width / 10;
            this.drawPosY = centralPosition;
        }
        this.finalDrawHeight = this.drawHeight;
        this.spriteStartCol = $7c6ee2a7bfeaced6$var$directionColWalkSprite.Top;
    }
    Pad.prototype.setKeyboardState = function(keyboardState) {
        this.keyboardState = keyboardState;
    };
    Pad.prototype.handleWalking = function() {
        if (this.keyboardState.turbo && this.finalSpeed <= this.speed * 4 && this.finalDrawHeight >= this.drawHeight / 10) {
            this.finalSpeed++;
            this.finalDrawHeight -= 4;
        }
        if (!this.keyboardState.turbo) {
            if (this.finalSpeed > this.speed) this.finalSpeed--;
            if (this.finalDrawHeight < this.drawHeight) this.finalDrawHeight += 0.5;
        }
        if (this.keyboardState.right) this.drawPosX += this.finalSpeed;
        else if (this.keyboardState.left) this.drawPosX += this.finalSpeed * -1;
        if (this.keyboardState.top) this.drawPosY += this.finalSpeed * -1;
        else if (this.keyboardState.bottom) this.drawPosY += this.finalSpeed;
        if (this.side === "Left") {
            var exceedsLeftBoundary = this.drawPosX <= 0;
            var exceedsRightBoundary = this.drawPosX + this.drawWidth >= this.canvas.width / 2;
            if (exceedsLeftBoundary) this.drawPosX = 0;
            else if (exceedsRightBoundary) this.drawPosX = this.canvas.width / 2 - this.drawWidth;
        } else {
            var exceedsLeftBoundary = this.canvas.width / 2 >= this.drawPosX;
            var exceedsRightBoundary = this.drawPosX + this.drawWidth >= this.canvas.width;
            if (exceedsLeftBoundary) this.drawPosX = this.canvas.width / 2;
            else if (exceedsRightBoundary) this.drawPosX = this.canvas.width - this.drawWidth;
        }
        var exceedsTopBoundary = this.drawPosY <= 0;
        var exceedsBottomBoundary = this.drawPosY + this.finalDrawHeight >= this.canvas.height;
        if (exceedsTopBoundary) this.drawPosY = 0;
        else if (exceedsBottomBoundary) this.drawPosY = this.canvas.height - this.finalDrawHeight;
    };
    Pad.prototype.render = function() {
        if (this.orquestrer.isPlaying) this.handleWalking();
        this.canvas.canvasContext.beginPath();
        this.canvas.canvasContext.fillStyle = "#FCEE09";
        this.canvas.canvasContext.fillRect(this.drawPosX, this.drawPosY, this.drawWidth, this.finalDrawHeight);
        this.canvas.canvasContext.closePath();
    };
    return Pad;
}();


var $79e0e90b4f17777b$exports = {};
$79e0e90b4f17777b$exports = new URL("ping.84740ffe.wav", import.meta.url).toString();


var $d28490789e4c83b5$export$85990f0f98a390bb = /** @class */ function() {
    function Sound() {
        this.music = new Audio();
        this.music.src = (0, (/*@__PURE__*/$parcel$interopDefault($79e0e90b4f17777b$exports)));
    }
    Sound.prototype.play = function() {
        this.music.play();
    };
    return Sound;
}();


var $d1296e6d8662977b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d1296e6d8662977b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
(function() {
    return $d1296e6d8662977b$var$__awaiter(this, void 0, void 0, function() {
        var keyboard, orquestrer, canvas, player1, player2, sound, ball, draw;
        return $d1296e6d8662977b$var$__generator(this, function(_a) {
            keyboard = new (0, $e622a235c1574eb5$export$6a77e7ef76b918fb)();
            orquestrer = new (0, $b724957aa8e823eb$export$cc1d9215c4c9725c)();
            canvas = new (0, $e5f72513d35cfb6f$export$8d01c972ee8b14a9)(orquestrer);
            player1 = new (0, $7c6ee2a7bfeaced6$export$4b43d51f29457384)(canvas, orquestrer, "Left");
            player2 = new (0, $7c6ee2a7bfeaced6$export$4b43d51f29457384)(canvas, orquestrer, "Right");
            sound = new (0, $d28490789e4c83b5$export$85990f0f98a390bb)();
            ball = new (0, $0dd05d01d611bc80$export$a83d7c3fa53790c9)(canvas, player1, player2, sound, orquestrer);
            draw = function() {
                canvas.canvasContext.clearRect(canvas.x, canvas.y, canvas.width, canvas.height);
                player1.setKeyboardState({
                    left: keyboard.keyboardState.KeyA,
                    right: keyboard.keyboardState.KeyD,
                    top: keyboard.keyboardState.KeyW,
                    bottom: keyboard.keyboardState.KeyS,
                    turbo: keyboard.keyboardState.ShiftLeft
                });
                player2.setKeyboardState({
                    left: keyboard.keyboardState.ArrowLeft,
                    right: keyboard.keyboardState.ArrowRight,
                    top: keyboard.keyboardState.ArrowUp,
                    bottom: keyboard.keyboardState.ArrowDown,
                    turbo: keyboard.keyboardState.Numpad0
                });
                player1.render();
                player2.render();
                ball.render();
                canvas.render();
                if (keyboard.keyboardState.Space) orquestrer.start();
                requestAnimationFrame(draw);
            };
            draw();
            return [
                2 /*return*/ 
            ];
        });
    });
})();


//# sourceMappingURL=pong.9b4d9343.js.map
